import { Col, Jumbotron, Row } from "react-bootstrap";
import Button from "@edaz/edazkit/Button/index";
import React from "react";
import { observer } from "mobx-react-lite";
import { registerView, ViewComponent } from "@frui.ts/views";
import SummaryViewModel from "../../viewModels/multiEshop/summaryMultiEshopViewModel";
import { EDAZGooglePayButton } from "../eshop/order/components/googlePayButton";
import styles from "./summaryMultiEshopView.module.scss";
import { IconType } from "@edaz/edazkit/Icon";

const SummaryView: ViewComponent<SummaryViewModel> = observer(({ vm }) => {
  const standardPaymentButtonOnClick = () => {
    if (vm.onContinue) {
      vm.onContinue(undefined);
    }
  };

  // As allowPaymentRequest is not recognized, we need to use the spread operator instead.
  const iframeProps = {
    allowpaymentrequest: "true",
  };

  const backButton = (
    <>
      {/* Back button visible only in mobile view */}
      <Button
        type="button"
        variant="light"
        className="btn-block px-lg-4 w-auto w-lg-100 d-sm-none"
        onClick={vm.onBack}
        disabled={vm.disabledButton}
        iconLeft={IconType.ArrowLeft}></Button>
      {/* Back button visible only in tablet/desktop view */}
      <Button type="button" variant="light" className="d-sm-block w-100 d-none" disabled={vm.disabledButton} onClick={vm.onBack}>
        {vm.tg("back")}
      </Button>
    </>
  );
  const continueButton = (
    <>
      {vm.isGooglePayPaymentMethodSelected && vm.isFinal ? (
        <>
          <EDAZGooglePayButton
            totalPrice={vm.total}
            locale={vm.locale}
            googlePayMetadata={vm.googlePayMetadata!}
            loading={!vm.isGooglePayMetadataReady}
            createOrder={vm.onContinue}
            validateOrder={vm.validateOrder}
            errorMessage={vm.localizationService.translateGeneral("errors.generic")}
          />
          {vm.googlePayPaymentFingerprint && (
            <iframe
              {...iframeProps}
              allow="payment"
              className={styles.fingerprintIframe}
              onLoad={vm.onGooglePayPaymentFingerprintLoaded}
              src={vm.googlePayPaymentFingerprint}></iframe>
          )}
        </>
      ) : (
        <Button
          type="button"
          variant="primary"
          className="w-100"
          iconRight={IconType.ArrowRight}
          iconRightAlign="left"
          onClick={standardPaymentButtonOnClick}
          disabled={vm.disabledButton}>
          {vm.tg(vm.isFinal ? "payment" : "continue")}
        </Button>
      )}
    </>
  );

  return (
    <Jumbotron className="p-0 pt-7 pb-4 multi-eshop">
      <Row className="px-4">
        <Col xs={12}>
          <h3>{vm.tg("summary")}</h3>
        </Col>
      </Row>
      {vm
        .uniqueCharges()
        .sort((a, b) => a.index - b.index)
        .map((charge) => (
          <Row key={charge.index} className="justify-content-between px-4">
            <Col xs={12} md={6} className="font-weight-bold">
              <label>{vm.vehicleCountForChargeType(charge.index)}</label>
            </Col>
            <Col xs="auto">
              <label>{vm.chargeTypeTotal(charge.index, charge.chargeTypeId, charge.fuelTypeId)}</label>
            </Col>
          </Row>
        ))}
      <div className="mx-4 mt-3 mb-4 px-4 border-top" />
      <Row className="justify-content-between px-4">
        <Col xs="auto" className="font-weight-bold">
          <label>{vm.tg("totalToPay")}</label>
        </Col>
        <Col xs="auto" className="font-weight-bold">
          <label>{vm.grandTotal}</label>
        </Col>
      </Row>
      {(vm.onBack || vm.onContinue) && (
        <div className="d-flex flex-row flex-lg-column flex-xl-row align-items-center justify-content-center mt-4 mb-3 px-xxl-4">
          {vm.onBack && (
            <Col xs={"auto"} sm={6} lg={12} xl={6} className="mb-2 text-center">
              {backButton}
            </Col>
          )}
          {vm.onContinue &&
            (vm.isGooglePayPaymentMethodSelected ? (
              <div className="mb-2 text-center">{continueButton}</div>
            ) : (
              <Col xs={"auto"} sm={vm.onBack ? 6 : 12} lg={12} xl={vm.onBack ? 6 : 12} className="flex-grow-1 mb-2 text-center">
                {continueButton}
              </Col>
            ))}
        </div>
      )}
    </Jumbotron>
  );
});

registerView(SummaryView, SummaryViewModel);
